import { c as _c } from "react/compiler-runtime";
export const LockIcon = t0 => {
  const $ = _c(9);
  const {
    selected
  } = t0;
  const fillColor = selected ? "#EFFCF8" : "#008254";
  const t1 = selected ? "#008254" : "#EFFCF8";
  let t2;
  if ($[0] !== t1) {
    t2 = <rect x="0.571533" width="40" height="40" rx="20" fill={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] !== fillColor) {
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M12.25 20C12.25 19.0335 13.0335 18.25 14 18.25H26C26.9665 18.25 27.75 19.0335 27.75 20V26C27.75 26.9665 26.9665 27.75 26 27.75H14C13.0335 27.75 12.25 26.9665 12.25 26V20ZM14 19.75C13.8619 19.75 13.75 19.8619 13.75 20V26C13.75 26.1381 13.8619 26.25 14 26.25H26C26.1381 26.25 26.25 26.1381 26.25 26V20C26.25 19.8619 26.1381 19.75 26 19.75H14Z" fill={fillColor} />;
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M15.25 16C15.25 13.3767 17.3767 11.25 20 11.25C22.6234 11.25 24.75 13.3767 24.75 16V18.25H23.25V16C23.25 14.2051 21.7949 12.75 20 12.75C18.2051 12.75 16.75 14.2051 16.75 16V18.25H15.25V16Z" fill={fillColor} />;
    $[2] = fillColor;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
    t5 = <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">{t2}{t3}{t4}</svg>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};